import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../Translations';
import { COLUMN_COUNT } from '../Columns';

interface Props {
  message: TPlainTextKey;
}

function ErrorRow({ message }: Props) {
  return (
    <tbody>
      <tr>
        <td
          colSpan={COLUMN_COUNT}
          className="p-12 text-center"
          style={{ color: 'var(--destructive)', fontSize: 'var(--text-sm)' }}
        >
          <T kind={message} />
        </td>
      </tr>
    </tbody>
  );
}

export default observer(ErrorRow);
